import * as React from 'react';
import { useCallback } from 'react';
import { InitialTableState, useTableReducer } from '../../../../components/data-table/lib';
import { List } from '../../../../components/list/list';
import { IAccessPoint, AccessPointsListAndCount, exportAccessPointsListAction, getAccessPointsList } from '../../../../services/core/accessPoints';
import { useUserSettingsContext } from '../../../../context/userSettings';
import { useWorldRequest } from '../../../../lib/useWorldRequest';
import { useAccessPointsListColumns } from './useAccessPointsListColumns';
import { useWorldAction } from '../../../../lib/useWorldAction';
import useNormalizedHeaderButtons from '../../../../components/controls/normalizedHeaderButtons';
import { useTranslation } from "@lib/useTypedTranslation";
import { Tooltip } from '../../../../components/tooltip/tooltip';
import './access-points-list.css';

const tableName = 'accessPointsList';
const defaultPageSize = 20;

export function AccessPointsList() {
  const { t } = useTranslation('coreAccessPoints');
  const { tablePageSizes } = useUserSettingsContext();
  const columns = useAccessPointsListColumns();

  const initialTableState: InitialTableState = {
    initialRows: 4,
    limit: tablePageSizes?.[tableName] || defaultPageSize,
    sort: { column: 4, direction: 'desc', field: 'score' }
  };
  const [tableReducerProperties, tableReducerFunctions] = useTableReducer<IAccessPoint>(tableName, initialTableState);
  const { offset, limit, sort, search, data, isLoading } = tableReducerProperties;

  const exportAccessPointsList = useWorldAction(exportAccessPointsListAction);
  const onExportClicked = async (): Promise<string> => {
    return exportAccessPointsList({ sort: { field: sort.field, order: sort.direction }, search });
  };

  const translationItems = {
    statusText: {
      key: 'ACCESS_POINT',
      ns: 'coreAccessPoints'
    },
    tableTitle: {
      text: <>{t('ACCESS_POINTS_TITLE')} <Tooltip popperContent={t('ACCESS_POINT_TITLE_TOOLTIP')} placement="right"><i className="fa fa-question-circle" style={{ color: '#7490b9', cursor: 'pointer' }} /></Tooltip></>
    }
  };

  const additionalHeaderButtons = useNormalizedHeaderButtons({
    export: {
      exportFunction: onExportClicked,
      filename: 'AccessPoints.csv',
      disabled: isLoading || !data?.length
    }
  });

  const listFetcher = useCallback(() => {
    return getAccessPointsList({ limit, offset, sort: { field: sort.field, order: sort.direction }, search });
  }, [offset, limit, sort, search]);

  return (
    <div className='core-access-points-list'>
      <List<IAccessPoint, AccessPointsListAndCount, 'totalCount', 'list', 'id'>
        dataId='core_access_points_list'
        customHeader={false}
        additionalHeaderButtons={additionalHeaderButtons}
        countDataPath='totalCount'
        listDataPath='list'
        hasCheckboxes={false}
        hasFilters={false}
        hasSearch
        translationItems={translationItems}
        columns={columns}
        fetcher={listFetcher}
        tableReducerFunctions={tableReducerFunctions}
        tableReducerProperties={tableReducerProperties}
        useRequestHook={useWorldRequest}
        options={{ rowIdDataPath: 'id', rowNameDataPath: 'bssid' }}
      />
    </div>
  );
}
